export const suggestedDocuments = [
      "business_proposal",
      "email_templates",
      "employee_agreement",
      "employee_training",
      "meeting_notes",
      "quote_estimate",
      "service_agreement"
];
